// These visuals require a specific measurement. latest-analysis supports either scope.
export const MEASUREMENT_VISUALS = [
    'measurement-info', 'measurement-values', 'measurement-texts', 'measurement-weather',
    'measurement-location', 'measurement-pattern-location', 'measurement-files',
];

export const getReportMeasurementContext = (template: any, measurementId?: number | null) => {
    const sections: any[] = Array.isArray(template?.sections) ? template.sections : [];
    const measurementSection = sections.find(section => MEASUREMENT_VISUALS.includes(section.visual));
    const analysisSection = sections.find(section => section.visual === 'latest-analysis');
    const allSectionsSupportMeasurement = sections.length > 0 && sections.every(section => (
        MEASUREMENT_VISUALS.includes(section.visual) || section.visual === 'latest-analysis'
    ));
    const analysisUsesMeasurement = measurementId != null || template?.scope === 'measurement'
        || (!template?.scope && Boolean(measurementSection) && allSectionsSupportMeasurement);
    const hasMeasurementSections = Boolean(measurementSection) || (Boolean(analysisSection) && analysisUsesMeasurement);
    const resolvedMeasurementId: number | null = hasMeasurementSections
        ? measurementId ?? measurementSection?.measurementId ?? (analysisUsesMeasurement ? analysisSection?.measurementId : null) ?? null
        : null;
    return {
        hasMeasurementSections,
        resolvedMeasurementId,
        analysisUsesMeasurement,
        isMeasurementOnly: hasMeasurementSections && allSectionsSupportMeasurement,
    };
};
